import { PageBlockType } from 'src/interfaces/PageBlock';

export function blockMenuLabel(type: PageBlockType, t: (key: string) => string): string {
  const addKeys: Partial<Record<PageBlockType, string>> = {
    text: 'system.pages.addTextBlock',
    divider: 'system.pages.addDividerBlock',
    trackMap: 'system.pages.addTrackMapBlock',
    map: 'system.pages.addMapBlock',
    sponsors: 'system.pages.addSponsorsBlock',
    competitionsList: 'system.pages.addCompetitionsListBlock',
    results: 'system.pages.addResultsBlock',
    image: 'system.pages.addImageBlock',
    columns: 'system.pages.addColumnsBlock',
    logo: 'system.pages.hero.addLogo',
    calendar: 'system.pages.hero.addCalendar',
    countdown: 'system.pages.hero.addCountdown',
    button: 'system.pages.hero.addButton',
    signupFlow: 'system.pages.addSignupFlowBlock',
    signupBreakdown: 'system.pages.addSignupBreakdownBlock',
  };
  const key = addKeys[type];
  return key ? t(key) : t(`system.pages.blockTypes.${type}`);
}
